import React from "react";

import { useSidebar } from "./hooks/useSidebar";

interface SidebarMenuItemProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * SidebarMenuItem - Individual menu item wrapper
 *
 * @param className - Additional CSS classes
 * @param children - Menu item content (typically SidebarMenuButton)
 */
export function SidebarMenuItem({
  className = "",
  children,
}: SidebarMenuItemProps) {
  const { state } = useSidebar();

  return (
    <li
      className={`
        flex items-center w-full
        ${className}
      `.trim()}
      role="menuitem"
      data-state={state}
    >
      {children}
    </li>
  );
}
